import { motion } from "framer-motion";

const OUTCOMES = [
  { title: "Confidence", body: "Participants understand the technology without unnecessary jargon." },
  { title: "Capability", body: "They practice using tools during the session." },
  { title: "Application", body: "Exercises are connected to real work." },
  { title: "Adoption", body: "Participants leave with workflows, prompts, ideas, and next steps they can continue using." },
];

export default function Results() {
  return (
    <section id="results" data-testid="results-section" className="py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, ease: "easeOut" }} className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-accent">
          What Participants Leave With
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }} className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-6 max-w-3xl">
          Useful Monday morning — <span className="italic text-primary">not someday.</span>
        </motion.h2>
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.15, ease: "easeOut" }} className="mt-8 max-w-2xl">
          <p className="text-base sm:text-lg leading-relaxed font-light text-foreground/80">
            Phillip designs programs around one question:
          </p>
          <p className="mt-4 font-display text-xl sm:text-2xl text-foreground font-medium">
            What will participants actually be able to do differently after this experience?
          </p>
        </motion.div>

        <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {OUTCOMES.map((o, i) => (
            <motion.div
              key={o.title}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: "easeOut" }}
              data-testid={`result-card-${o.title.toLowerCase()}`}
              className="rounded-[2rem] border border-[#D8D4CA] bg-muted/40 p-8"
            >
              <span className="font-display text-4xl text-outline select-none">0{i + 1}</span>
              <h3 className="font-display text-2xl tracking-tight mt-4">{o.title}</h3>
              <p className="mt-4 text-sm leading-relaxed font-light text-foreground/70">{o.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
